import { lazy } from "react";
import RouteGuard from "../routerPermission";

const CashCollectionsPage = lazy(() => import("@/widgets/transaction/CashCollectionsPage"));
const TransactionDetailByIdShell = lazy(
  () => import("@/widgets/transaction/TransactionDetailByIdShell"),
);
const TransactionDetailByOrderShell = lazy(
  () => import("@/widgets/transaction/TransactionDetailByOrderShell"),
);

const TransactionRoutes = {
  path: "transactions",
  children: [
    {
      path: "",
      element: (
        <RouteGuard resource="order" action="read">
          <CashCollectionsPage />
        </RouteGuard>
      ),
    },
    // by-order BEFORE :id so "by-order" isn't matched as an id.
    {
      path: "by-order/:orderId",
      element: (
        <RouteGuard resource="order" action="read">
          <TransactionDetailByOrderShell />
        </RouteGuard>
      ),
    },
    {
      path: ":id",
      element: (
        <RouteGuard resource="order" action="read">
          <TransactionDetailByIdShell />
        </RouteGuard>
      ),
    },
  ],
};

export default TransactionRoutes;
